import { queryClient } from '../index';
import { threadsKeys } from './threads.keys';
export const threadsQueryOptimisticAdd = (thread) => {
    queryClient.setQueryData(threadsKeys.all(), (prev) => {
        if (!prev.has(thread.id)) {
            prev.set(thread.id, thread.name);
        }
        return prev;
    });
};
export const threadHistoryQueryOptimisticUpdate = (history) => {
    queryClient.setQueryData(threadsKeys.history(), (prev) => {
        if (!prev || history.thread_list.length === 0) {
            return [];
        }
        if (prev.length === 0) {
            return [history.thread_list[0]];
        }
        if (prev[0].id === history.thread_list[0].id) {
            return prev;
        }
        return [history.thread_list[0], ...prev];
    });
};
export const threadHistoryPageQueryOptimisticUpdate = (history) => {
    queryClient.setQueryData(threadsKeys.historyPages(), (prev) => {
        if (!prev || prev.pages.length === 0 || history.thread_list.length === 0) {
            return prev;
        }
        const { id, timestamp } = history.thread_list[0];
        if (prev.pages[0].items[0]?.id === id) {
            return prev;
        }
        // New references are required: mutating the cached object in place keeps
        // the same identity, so observers are never notified and the UI stays stale.
        const firstPage = { ...prev.pages[0], items: [{ id, timestamp }, ...prev.pages[0].items] };
        return { ...prev, pages: [firstPage, ...prev.pages.slice(1)] };
    });
};
//# sourceMappingURL=threads.query.update.js.map